/* eslint-disable no-param-reassign */
import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "store";
import type {
  SpaceEntity,
  SpaceFilter,
} from "../../../domain/space/space.types";

export interface SpaceState {
  spaces: SpaceEntity[] | null;
  spaceFilters: SpaceFilter[] | null;
  currentSpace: SpaceEntity | null;
  isLoadingSpaceFilters: boolean;
  isLoadingSpaces: boolean;
  isLoadingSpace: boolean;
}

export const surveyInitialState: SpaceState = {
  spaces: null,
  currentSpace: null,
  spaceFilters: null,
  isLoadingSpaceFilters: false,
  isLoadingSpaces: false,
  isLoadingSpace: false,
};

const slice = createSlice({
  name: "Space",
  initialState: surveyInitialState,
  reducers: {
    setSpaces: (state, action: PayloadAction<SpaceEntity[]>) => {
      state.spaces = action.payload;
    },
    setSpaceFilters: (state, action: PayloadAction<SpaceFilter[]>) => {
      state.spaceFilters = action.payload;
    },
    setCurrentSpace: (state, action: PayloadAction<SpaceEntity>) => {
      state.currentSpace = action.payload;
    },
    setSpacesLoading: (state) => {
      state.isLoadingSpaces = true;
    },
    setEndSpacesLoading: (state) => {
      state.isLoadingSpaces = false;
    },
    setSpaceFiltersLoading: (state) => {
      state.isLoadingSpaceFilters = true;
    },
    setEndSpaceFiltersLoading: (state) => {
      state.isLoadingSpaceFilters = false;
    },
    setSpaceLoading: (state) => {
      state.isLoadingSpace = true;
    },
    setEndSpaceLoading: (state) => {
      state.isLoadingSpace = false;
    },
  },
});

export const {
  setEndSpaceLoading,
  setEndSpacesLoading,
  setSpaceLoading,
  setSpacesLoading,
  setSpaceFiltersLoading,
  setEndSpaceFiltersLoading,
  setSpaces,
  setCurrentSpace,
  setSpaceFilters,
} = slice.actions;

export const getSpacesSelector = createSelector(
  (state: RootState) => state.spaceState,
  (state) => state.spaces,
);

export default slice.reducer;
